import styled from 'styled-components';

export const Spinner = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
